import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { tipoUsuario } from "../../constants/tipoUsuario";
import { useLogin } from "../../hooks/useLogin";
import { useNavigate } from "react-router-dom";
import Validacoes from "../../utils/validacoes";
import Masks from "../../utils/masks";
import Style from "./index.module.css";
import Alert from "../shared/alert/Alert";

export const Login = () => {
  const [codUsuario, setCodUsuario] = useState("");
  const [senUsuario, setSenUsuario] = useState("");
  const [tipUsuario, setTipUsuario] = useState(tipoUsuario.FORNECEDOR);
  const [tipoPessoa, setTipoPessoa] = useState("JURIDICA");
  const [errors, setErrors] = useState({});
  const [showSenha, setShowSenha] = useState(false);
  const navigate = useNavigate();

  const { login, isLoading } = useLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};

    if (!codUsuario.trim()) {
      validationErrors.codUsuario =
        tipUsuario === tipoUsuario.COMPRADOR
          ? "Código de usuário é obrigatório."
          : tipoPessoa === "JURIDICA"
            ? "CNPJ é obrigatório."
            : tipoPessoa === "FISICA"
              ? "CPF é obrigatório."
              : "Código de fornecedor é obrigatório.";
    } else if (tipUsuario === tipoUsuario.FORNECEDOR) {
      if (tipoPessoa === "JURIDICA") {
        if (!Validacoes.cnpj(codUsuario)) validationErrors.codUsuario = "CNPJ inválido.";
      } else if (tipoPessoa === "FISICA") {
        if (!Validacoes.cpf(codUsuario)) validationErrors.codUsuario = "CPF inválido.";
      }
    }

    if (!senUsuario.trim()) {
      validationErrors.senUsuario = "Senha é obrigatória.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      codope: codUsuario,
      senope: senUsuario,
      tipusu: tipUsuario === tipoUsuario.COMPRADOR ? "COMPRADOR" : "FORNECEDOR"
    }

    try {
      const response = await login(payload);

      if (response.docs.status === "PRIMEIRO_ACESSO") {
        navigate("/cadastro");
      } else if (response.docs.status === "CADASTRO_NAO_APROVADO") {
        await Alert({
          icon: "warning",
          title: "Aviso",
          message: `${response.docs.message}`,
          showConfirmButton: true,
          confirmButtonText: "OK",
        });
      } else {
        navigate("/home");
      }
    } catch (error) {
    }
  };

  const handleCodChange = (value) => {
    if (tipUsuario === tipoUsuario.FORNECEDOR) {
      value = tipoPessoa === "JURIDICA" ? Masks.cnpj(value) : tipoPessoa === "FISICA" ? Masks.cpf(value) : value;
    }

    setCodUsuario(value);

    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        codUsuario:
          tipUsuario === tipoUsuario.COMPRADOR
            ? "Código de usuário é obrigatório."
            : tipoPessoa === "JURIDICA"
              ? "CNPJ é obrigatório."
              : tipoPessoa === "FISICA" ? "CPF é obrigatório." : "Código de fornecedor é obrigatório"
      }));
    } else if (tipUsuario === tipoUsuario.FORNECEDOR) {
      if (tipoPessoa === "JURIDICA") {
        setErrors((prev) => ({
          ...prev,
          codUsuario: Validacoes.cnpj(value) ? "" : "CNPJ inválido."
        }));
      } else if (tipoPessoa === "FISICA") {
        setErrors((prev) => ({
          ...prev,
          codUsuario: Validacoes.cpf(value) ? "" : "CPF inválido."
        }));
      }
    } else {
      setErrors((prev) => ({ ...prev, codUsuario: "" }));
    }
  };

  const handleTipoUsuarioChange = (value) => {
    setTipUsuario(Number(value));
    setCodUsuario("");
    setErrors({});
  };

  const handleTipoPessoaChange = (value) => {
    setTipoPessoa(value);
    setCodUsuario("");
    setErrors({});
  };

  return (
    <div className={Style.container}>
      <h1 style={{ textAlign: "center", fontStyle: "normal" }}>Login</h1>
      <br />

      <form className={Style.form} onSubmit={handleSubmit} noValidate>
        <label>
          Tipo de usuário:
          <select
            value={tipUsuario}
            onChange={(e) => handleTipoUsuarioChange(e.target.value)}
            disabled={isLoading}
          >
            <option value={tipoUsuario.FORNECEDOR}>Fornecedor</option>
            <option value={tipoUsuario.COMPRADOR}>Comprador</option>
          </select>
        </label>

        {tipUsuario === tipoUsuario.FORNECEDOR && (
          <label>
            Tipo de pessoa:
            <select
              value={tipoPessoa}
              onChange={(e) => handleTipoPessoaChange(e.target.value)}
              disabled={isLoading}
            >
              <option value="FISICA">Pessoa Física</option>
              <option value="JURIDICA">Pessoa Jurídica</option>
              <option value="INTERNACIONAL">Pessoa Internacional</option>
            </select>
          </label>
        )}

        <label>
          {tipUsuario === tipoUsuario.COMPRADOR
            ? "Código de usuário:"
            : tipoPessoa === "JURIDICA"
              ? "CNPJ:"
              : tipoPessoa === "FISICA"
                ? "CPF:"
                : "Código de fornecedor:"}
          <input
            type="text"
            value={codUsuario}
            onChange={(e) => handleCodChange(e.target.value)}
            placeholder={
              tipUsuario === tipoUsuario.COMPRADOR
                ? "Digite seu código de usuário"
                : tipoPessoa === "JURIDICA"
                  ? "Digite seu CNPJ"
                  : tipoPessoa === "FISICA"
                    ? "Digite seu CPF"
                    : "Digite seu código de fornecedor"
            }
            disabled={isLoading}
          />
          {errors.codUsuario && <span className="error">{errors.codUsuario}</span>}
        </label>

        <label style={{ display: "flex", flexDirection: "column", position: "relative" }}>
          Senha:
          <div style={{ position: "relative" }}>
            <input
              type={showSenha ? "text" : "password"}
              value={senUsuario}
              onChange={(e) => setSenUsuario(e.target.value)}
              placeholder="Digite sua senha"
              style={{ paddingRight: "2.5rem", width: "100%" }}
              disabled={isLoading}
            />
            <span
              onClick={() => !isLoading && setShowSenha(!showSenha)}
              style={{
                position: "absolute",
                right: "10px",
                top: "60%",
                transform: "translateY(-50%)",
                cursor: isLoading ? "not-allowed" : "pointer",
                color: isLoading ? "#ccc" : "#555",
                opacity: isLoading ? 0.6 : 1,
              }}
            >
              {showSenha ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {errors.senUsuario && <span className="error">{errors.senUsuario}</span>}
        </label>

        <p style={{ fontStyle: "normal", fontWeight: "400", fontSize: "10pt" }}>
          <span style={{ fontWeight: "500" }}>
            Não possuí login? Realize seu cadastro 
            <span
              onClick={() => !isLoading && navigate("/cadastro")}
              style={{
                cursor: isLoading ? "default" : "pointer",
                color: isLoading ? "#ccc" : "#007AFF",
                textDecoration: "none",
                pointerEvents: isLoading ? "none" : "auto",
                marginLeft: "2px"
              }}
            >
            aqui.
            </span>
          </span>
        </p>

        <button
          type="submit"
          disabled={isLoading}
          style={{
            opacity: isLoading ? 0.7 : 1,
            cursor: isLoading ? "not-allowed" : "pointer"
          }}
        >
          {isLoading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
};